// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/font.css
// module id = N0MC
// module chunks = 14